import React from 'react';
import { commitments } from '../data/advantagePricing';
export function AdvantageGuarantees() {
  return <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch" data-id="element-34" data-mp="1ui2svukgethm">
      <div className="bg-slate-900/40 border border-[#7FE0C3]/40 rounded-2xl p-10 relative flex flex-col justify-center" data-id="element-35" data-mp="28gu335w73v0h">
        <div className="absolute top-0 left-0 w-full h-1 bg-[#7FE0C3] rounded-t-2xl" data-id="element-36" data-mp="23hpr67hvzj6g" />
        <div className="text-sm text-[#7FE0C3] uppercase tracking-widest mb-5" data-id="element-37" data-mp="2ieq95ja9zzrq">
          Our Guarantee to You
        </div>
        <p className="text-3xl md:text-4xl font-bold text-white leading-snug mb-5" data-id="element-38" data-mp="2dfdp16ash6su">
          100% of our fees back inside the first 30 days of the campaign.
        </p>
        <p className="text-slate-400 text-lg leading-relaxed" data-id="element-39" data-mp="2n5ggh229icp2">
          We take the bigger risk on this partnership than you do. If the system
          is not working in the first 30 days, you are not paying for it.
        </p>
      </div>

      <div className="bg-slate-900/40 border border-slate-800 rounded-2xl p-10" data-id="element-40" data-mp="2w87wlf631wn1">
        <div className="text-sm text-[#7FE0C3] uppercase tracking-widest mb-6" data-id="element-41" data-mp="1dnb75ms76wp8">
          What We Need to Make That Guarantee
        </div>
        <ol className="space-y-6" data-id="element-42" data-mp="1ingwuxewq94o">
          {commitments.map((commitment, index) => <li key={commitment.title} className="flex items-start" data-id="element-43" data-mp="1nmk0qej5i9b2" data-mpi={index}>
              <span className="w-8 h-8 rounded-full bg-[#7FE0C3]/10 border border-[#7FE0C3]/30 text-[#7FE0C3] text-sm font-bold flex items-center justify-center mr-4 mt-0.5 shrink-0" data-id="element-44" data-mp="1rmu5xoz4cvov">
                {index + 1}
              </span>
              <div data-id="element-45" data-mp="21i5jw52pdyvk">
                <div className="text-white font-medium text-lg" data-id="element-46" data-mp="26ayomsy6977n">
                  {commitment.title}
                </div>
                <p className="text-slate-400 text-base leading-relaxed mt-1.5" data-id="element-47" data-mp="2babbhdp1mea8">
                  {commitment.description}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </div>;
}